(function () {
  'use strict';

  angular.module('app').component('packageDetail', packageDetail());

  function packageDetail() {
    return {
      bindings: {
        item: '=',
        mode: '<',
        activeTab: '<',
        onSavedItem: '&',
        defaultLanguage: '<',
        userLanguageCode: '<',
      },
      controller: PackageDetailComponent,
      controllerAs: 'vm',
      templateUrl: './app/ajs/packages/package-detail/package-detail.component.html',
    };
  }

  PackageDetailComponent.$inject = [
    'UtilService',
    '$location',
    'PackageService',
    'PackageContentService',
    'MeasurementUnitService',
    'SessionService',
    'ProductCategoryService',
    'TaxService',
    'ProductService',

    // Angular downgraded service
    'categoryService',
    'categoryModalService',
    'facilityService',
    'facilityModalService',
    'whatToBringService',
    'whatToBringModalService',
    'locationService',
    'locationModalService',
    'utilService',
    'companyService',
  ];

  function PackageDetailComponent(
    UtilService,
    $location,
    PackageService,
    PackageContentService,
    MeasurementUnitService,
    SessionService,
    ProductCategoryService,
    TaxService,
    ProductService,

    // Angular downgraded service
    categoryService,
    categoryModalService,
    facilityService,
    facilityModalService,
    whatToBringService,
    whatToBringModalService,
    locationService,
    locationModalService,
    utilService,
    companyService
  ) {
    var vm = this;

    vm.UtilService = new UtilService(vm);

    vm.checkedCategory = {};
    vm.checkedFacility = {};
    vm.checkedWhatToBring = {};

    vm.productSearchId = null;

    // Methods
    vm.selectProductCategory = selectProductCategory;
    vm.openProductCategoriesModal = openProductCategoriesModal;
    vm.openLocationsModal = openLocationsModal;
    vm.openCategoriesModal = openCategoriesModal;
    vm.openFacilitiesModal = openFacilitiesModal;
    vm.openWhatToBringsModal = openWhatToBringsModal;
    vm.openPackageContentsModal = openPackageContentsModal;

    vm.editPackage = editPackage;
    vm.cancelEdit = cancelEdit;
    vm.savePackage = savePackage;
    vm.cancel = cancel;

    vm.selectAssociatedProviders = selectAssociatedProviders;
    vm.onAssociatedProviderSaved = onAssociatedProviderSaved;
    vm.onAssociatedProviderDeleted = onAssociatedProviderDeleted;
    vm.onSelectedTab = onSelectedTab;
    vm.selectAccounting = selectAccounting;

    vm.selectCostsAndPrices = selectCostsAndPrices;
    vm.onCostsAndPricesSaved = onCostsAndPricesSaved;

    vm.selectAssociatedTaxes = selectAssociatedTaxes;
    vm.onAssociatedTaxesSaved = onAssociatedTaxesSaved;
    vm.onAssociatedTaxesCanceled = onAssociatedTaxesCanceled;

    vm.$onInit = function () {
      vm.atvCrEnabled = SessionService.getSelectedAccountCompany().atv_cr_enabled;

      if (vm.item.id) {
        // Edit
        vm.active = vm.activeTab ? parseInt(vm.activeTab) : 0;

        setItemOptions(vm.item, vm.mode);
        getServerData(vm.item);
      } else {
        // New
        vm.createMode = true;

        vm.item = {
          company_id: SessionService.getSelectedAccountCompany().id,
        };

        // Initializers
        getLocations();
        getProductCategories('');
      }

      // Initializers
      getCompany();

      getPackages();

      getCategories();
      getFacilities();
      getWhatToBrings();
    };

    vm.openSearchCabys = function (item) {
      const succesCallBack = (itemObj) => {
        vm.item.cabys_code = itemObj.codigo;
        vm.item.cabys_description = itemObj.descripcion;
        vm.item.cabys_tax = itemObj.impuesto;
      };

      ProductService.openSearchCabys(item, succesCallBack);
    };

    vm.searchCabys = function () {
      if (!vm.item.cabys_code || vm.item.cabys_code.length < 13) return;

      let searchBy = 'codigo=' + vm.item.cabys_code.toLowerCase();

      vm.clearCabys();

      vm.invalidCabys = false;

      vm.searchingCabys = true;
      ProductService.searchCabys(searchBy).then(function (data) {
        if (data[0] && data[0].codigo) {
          vm.item.cabys_code = data[0].codigo;
          vm.item.cabys_description = data[0].descripcion;
          vm.item.cabys_tax = data[0].impuesto;

          vm.invalidCabys = false;
        } else {
          vm.invalidCabys = true;
        }

        vm.searchingCabys = false;
      });
    };

    vm.clearCabys = function () {
      vm.item.cabys_description = '';
      vm.item.cabys_tax = '';
    };

    function setItemOptions(item, mode = '') {
      vm.createMode = false;
      vm.editMode = false;
      vm.viewMode = true;

      if (mode === 'edit') {
        vm.editMode = true;

        editPackage();
      }

      vm.productIsExempt = item.is_exempt || false;

      vm.productCategorySelected = item.product_category;

      setCheckedCategories(item.category_ids);
      setCheckedFacilities(item.facility_ids);
      setCheckedWhatToBring(vm.item.what_to_bring_ids);

      vm.customTaxConfiguration = item.custom_tax_configuration;

      vm.itemName = item.name;

      vm.originalItem = angular.copy(item); // store server data

      vm.flashMessage = vm.UtilService._displayFlashMessage();
    }

    function getServerData(item) {
      // To reload code number consecutive
      getProductCategories('');
    }

    function editPackage() {
      vm.editMode = true;
      vm.viewMode = false;

      // Initializers
      getLocations();
    }

    function cancelEdit() {
      vm.item = vm.originalItem;
      setItemOptions(vm.item);
    }

    function getCompany() {
      companyService
        .getCompany(vm.item.company_id, {
          skip_check_role: true,
          lang: vm.userLanguageCode,
        })
        .subscribe((response) => {
          // defaultLanguage
          if (response.country.country_setting) {
            vm.taxTypes = response.country.country_setting.tax_types;
            vm.taxRateCodes = response.country.country_setting.tax_rate_codes;
          }

          vm.measurementUnits = MeasurementUnitService.setMeasurementUnitsByProductType(
            response.measurement_units,
            'package'
          );

          if (!vm.createMode) {
            vm.measurementUnit = vm.UtilService.findItemInArray(
              vm.measurementUnits,
              'id',
              vm.item.measurement_unit_id
            );
          }
        });
    }

    // ----- PRODUCT CATEGORIES ----- //

    function getProductCategories(option) {
      var params = {
        get: 'active',
        by_product_type: 'package',
        skip_check_role: true,
        // lang: vm.defaultLanguage
        lang: vm.userLanguageCode,
      };

      vm.loadingProductCategories = true;
      ProductCategoryService.getProductCategories(params).then(function (data) {
        vm.productCategories = data.items;
        vm.loadingProductCategories = false;

        if (option === 'update') {
          var productCategory = vm.UtilService.findItemInArray(
            vm.productCategories,
            'id',
            vm.productCategorySelected.id
          );
          vm.productCategorySelected = null;

          selectProductCategory(productCategory);
        }
      });
    }

    function selectProductCategory(productCategory) {
      if (vm.productCategorySelected && vm.productCategorySelected.id === productCategory.id) {
        // Same product category is selected
        return;
      }

      vm.productCategorySelected = productCategory;
      vm.item.code_number = '';

      // Edit mode
      if (vm.editMode) {
        // Same product category as the item
        if (vm.originalItem.product_category_id === productCategory.id) {
          vm.item.code = vm.originalItem.code;
          vm.item.code_number = vm.originalItem.code_number;
        } else if (productCategory.coding_type === 'automatic') {
          vm.item.code =
            productCategory.coding_prefix + productCategory.nextProductCodeNumberToAssign;
          vm.item.code_number = productCategory.nextProductCodeNumberToAssign;
        }
      }
    }

    function openProductCategoriesModal() {
      var successCallback = function () {
        getProductCategories('update');
      };

      ProductCategoryService.openProductCategoriesModal(successCallback);
    }

    // ----- LOCATIONS ----- //

    function getLocations() {
      if (vm.locations) return;

      var params = {
        get: 'active',
        skip_check_role: true,
        // lang: vm.defaultLanguage
        lang: vm.userLanguageCode,
      };

      vm.loadingLocations = true;
      locationService.getLocations(params).subscribe((response) => {
        vm.locations = locationService.groupLocations(response); // , '', 'locations'
        vm.loadingLocations = false;
      });
    }

    function openLocationsModal() {
      var successCallback = function () {
        vm.locations = null;
        getLocations();
      };

      locationModalService.openLocationsModal(successCallback);
    }

    // ----- PACKAGES ----- //

    function getPackages() {
      var params = {
        get: 'all',
        // packageId: vm.item.id,
        skip_check_role: true,
      };

      vm.loadingPackages = true;
      PackageService.getPackages(params).then(function (data) {
        // vm.packages = data.items;

        vm.packages = [];

        data.items.forEach(function (item, index) {
          item.prev = data.items[index - 1];
          item.next = data.items[index + 1];

          vm.packages.push(item);
        });

        if (!vm.createMode) {
          vm.productSelected = angular.copy(vm.item); // To keep diferent scope as we modify .prev / .next

          const productFound = vm.packages.find((product) => product.id === vm.item.id);

          vm.productSelected.prev = productFound.prev;
          vm.productSelected.next = productFound.next;

          vm.productSearchId = vm.item.id;
        }

        // Related products
        vm.relatedPackages = vm.packages.filter((product) => {
          return product.id !== vm.item.id;
        });

        vm.loadingPackages = false;
      });
    }

    vm.selectProduct = function (product) {
      if (vm.productSelected && vm.productSelected.id === product.id) {
        return;
      }

      $location.path(`/packages/${product.id}`);
    };

    vm.goToOtherProduct = function (otherProductId) {
      let product = vm.UtilService.findItemInArray(vm.packages, 'id', otherProductId);

      vm.selectProduct(product);
    };

    function openPackageContentsModal() {
      PackageContentService.openPackageContentsModal(vm.item);
    }

    // ----- CATEGORIES ----- //

    function getCategories() {
      var params = {
        get: 'package',
        skip_check_role: true,
        // lang: vm.defaultLanguage
        lang: vm.userLanguageCode,
      };

      categoryService.getCategories(params).subscribe((response) => {
        vm.categories = response;
      });
    }

    function openCategoriesModal() {
      const successCallback = () => {
        getCategories();
      };

      categoryModalService.openCategoriesModal(successCallback);
    }

    function setCheckedCategories(category_ids) {
      category_ids.forEach((key) => {
        vm.checkedCategory[key] = true;
      });
    }

    // ----- FACILITIES ----- //

    function getFacilities() {
      var params = {
        get: 'package',
        skip_check_role: true,
        // lang: vm.defaultLanguage
        lang: vm.userLanguageCode,
      };

      facilityService.getFacilities(params).subscribe((response) => {
        vm.facilities = response;
      });
    }

    function openFacilitiesModal() {
      const successCallback = () => {
        getFacilities();
      };

      facilityModalService.openFacilitiesModal(successCallback);
    }

    function setCheckedFacilities(facility_ids) {
      facility_ids.forEach((key) => {
        vm.checkedFacility[key] = true;
      });
    }

    // ----- WHAT TO BRING ----- //

    function getWhatToBrings() {
      var params = {
        get: 'package',
        skip_check_role: true,
        // lang: vm.defaultLanguage
        lang: vm.userLanguageCode,
      };

      whatToBringService.getWhatToBrings(params).subscribe((response) => {
        vm.whatToBrings = response;
      });
    }

    function openWhatToBringsModal() {
      const successCallback = () => {
        getWhatToBrings();
      };

      whatToBringModalService.openWhatToBringsModal(successCallback);
    }

    function setCheckedWhatToBring(what_to_bring_ids) {
      what_to_bring_ids.forEach(function (key) {
        vm.checkedWhatToBring[key] = true;
      });
    }

    // Create/Update
    function savePackage(isFormValid) {
      vm.formErrors = false;

      if (
        !isFormValid ||
        vm.productCategories.length === 0 ||
        vm.locations === 0
        // || (vm.atvCrEnabled && !vm.item.cabys_description)
      ) {
        vm.serverErrors = [];
        vm.formErrors = true;

        vm.UtilService.scrollToTop();

        return;
      }

      vm.item.category_ids = utilService.parseItemIds(vm.checkedCategory);
      vm.item.facility_ids = utilService.parseItemIds(vm.checkedFacility);
      vm.item.what_to_bring_ids = utilService.parseItemIds(vm.checkedWhatToBring);

      vm.sendingForm = true;
      PackageService.savePackage(vm.item).then(function (data) {
        var status = data.status;
        var response = data.response;

        if (status) {
          // Success
          if (!vm.editMode) {
            // create
            vm.onSavedItem({ item: response });
          } else {
            vm.item = response;
            setItemOptions(response);

            vm.measurementUnit = vm.UtilService.findItemInArray(
              vm.measurementUnits,
              'id',
              response.measurement_unit_id
            );

            getServerData(response);

            vm.flashMessage = vm.UtilService._clearFlashMessage();
            vm.UtilService.scrollToTop();
          }
        } else {
          vm.serverErrors = vm.UtilService._showItemServerErrors(response.errors);
          vm.formErrors = true;

          vm.UtilService.scrollToTop();
        }

        vm.sendingForm = false;
      });
    }

    function cancel() {
      vm.createMode = false;
      vm.editMode = false;
      vm.viewMode = true;
    }

    // ----- ASSOCIATED PROVIDERS ----- //

    function selectAssociatedProviders() {
      vm.showAssociatedProviders = true;
    }

    function onAssociatedProviderSaved(product, items) {
      vm.item.default_provider_id = product.default_provider_id;

      vm.item.associated_providers = items;
      vm.originalItem.associated_providers = items;
    }

    function onAssociatedProviderDeleted(items) {
      vm.item.associated_providers = items;
      vm.originalItem.associated_providers = items;
    }

    function onSelectedTab(tab) {
      vm.active = tab;
    }

    // ----- ACCOUNTING -----
    function selectAccounting() {
      vm.showAccounting = true;
    }

    // ----- COSTS AND PRICES -----

    function selectCostsAndPrices() {
      vm.showCostsAndPrices = false;

      setTimeout(() => {
        vm.showCostsAndPrices = true;
      }, 100); // hack

      // vm.showCostsAndPrices = true;
    }

    function onCostsAndPricesSaved(associated_providers) {
      vm.item.associated_providers = associated_providers;
      vm.originalItem.associated_providers = associated_providers;
    }

    // ----- ASSOCIATED TAXES -----

    function selectAssociatedTaxes(reload) {
      if (vm.taxes && !reload) {
        return;
      }

      let productCategoryAssociatedTaxes = {
        purchases: [],
        sales: [],
      };

      if (vm.item.product_category.associated_taxes) {
        vm.item.product_category.associated_taxes.map((associated_tax) => {
          if (associated_tax.scope_type === 'purchases') {
            productCategoryAssociatedTaxes.purchases.push(associated_tax);
          } else {
            productCategoryAssociatedTaxes.sales.push(associated_tax);
          }
        });
      }

      vm.taxes = TaxService.setAssociatedTaxes(
        productCategoryAssociatedTaxes,
        vm.item.associated_taxes,
        vm.taxTypes
      );
      vm.taxesOriginal = angular.copy(vm.taxes);
    }

    function onAssociatedTaxesSaved(product) {
      if (!vm.customTaxConfiguration) {
        delete product.exonerations;
      }

      vm.item = product;
      vm.originalItem = angular.copy(vm.item);
      // vm.taxesOriginal = angular.copy(vm.taxes);

      selectAssociatedTaxes(true);
    }

    function onAssociatedTaxesCanceled() {
      vm.customTaxConfiguration = vm.originalItem.custom_tax_configuration;

      vm.taxes = vm.taxesOriginal;
      vm.taxesOriginal = angular.copy(vm.taxes);
    }
  }
})();
